import {
  initialState,
  Actions,
  State,
  SELECT_ONE_CALENDAR,
  SELECT_ONE_CALENDAR_SUCCESS,
  SELECT_ONE_CALENDAR_ERROR,
  RESET_SELECT_ONE_CALENDAR,
} from "../../types/calendar/selectOne";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case SELECT_ONE_CALENDAR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case SELECT_ONE_CALENDAR_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case SELECT_ONE_CALENDAR_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      };
    case RESET_SELECT_ONE_CALENDAR:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducers;
